import {
  USER_TOKEN,
  USER_INFO,
} from './mutation-types.js'

export default {
  setUserToken({ commit }, user_token){
    commit(USER_TOKEN,{ user_token })
  },
  async reqUserInfo(){
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js